// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/nut-icons.eot?xegvp7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/nut-icons.ttf?xegvp7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/nut-icons.woff?xegvp7", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "nut-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-],
[class*=" icon-"] {
  font-family: "nut-icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  font-size: 4em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-nut-solid-nut-at:before {
  content: "\\e900";
}

.icon-nut-solid-nut-baby:before {
  content: "\\e901";
}

.icon-nut-solid-nut-care:before {
  content: "\\e902";
}

.icon-nut-solid-nut-child:before {
  content: "\\e903";
}

.icon-nut-solid-nut-dislike:before {
  content: "\\e904";
}

.icon-nut-solid-nut-exclamation:before {
  content: "\\e905";
}

.icon-nut-solid-nut-family:before {
  content: "\\e906";
}

.icon-nut-solid-nut-free:before {
  content: "\\e907";
}

.icon-nut-solid-nut-hands:before {
  content: "\\e908";
}

.icon-nut-solid-nut-heart:before {
  content: "\\e909";
}

.icon-nut-solid-nut-instagram:before {
  content: "\\e90a";
}

.icon-nut-solid-nut-like:before {
  content: "\\e90b";
}

.icon-nut-solid-nut-list:before {
  content: "\\e90c";
}

.icon-nut-solid-nut-paid:before {
  content: "\\e90d";
}

.icon-nut-solid-nut-play:before {
  content: "\\e90e";
}

.icon-nut-solid-nut-puzzle:before {
  content: "\\e90f";
}

.icon-nut-solid-nut-tiktok:before {
  content: "\\e910";
}

.icon-nut-solid-nut-toddler:before {
  content: "\\e911";
}

.icon-nut-solid-nut-translate:before {
  content: "\\e912";
}`, "",{"version":3,"sources":["webpack://./src/assets/icons/old/nut-icons.css"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,4CAAA;EACA,4LACI;EAGJ,mBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAKA;;EAEI,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EAEA,mCAAA;EACA,kCAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAMA;EACI,gBAAA;AAHJ;;AAKA;EACI,gBAAA;AAFJ;;AAIA;EACI,gBAAA;AADJ;;AAGA;EACI,gBAAA;AAAJ;;AAEA;EACI,gBAAA;AACJ;;AACA;EACI,gBAAA;AAEJ;;AAAA;EACI,gBAAA;AAGJ;;AADA;EACI,gBAAA;AAIJ;;AAFA;EACI,gBAAA;AAKJ;;AAHA;EACI,gBAAA;AAMJ;;AAJA;EACI,gBAAA;AAOJ;;AALA;EACI,gBAAA;AAQJ;;AANA;EACI,gBAAA;AASJ;;AAPA;EACI,gBAAA;AAUJ;;AARA;EACI,gBAAA;AAWJ;;AATA;EACI,gBAAA;AAYJ;;AAVA;EACI,gBAAA;AAaJ;;AAXA;EACI,gBAAA;AAcJ","sourcesContent":["@font-face {\n    font-family: 'nut-icons';\n    src: url('fonts/nut-icons.eot?xegvp7');\n    src:\n        url('fonts/nut-icons.eot?xegvp7#iefix') format('embedded-opentype'),\n        url('fonts/nut-icons.ttf?xegvp7') format('truetype'),\n        url('fonts/nut-icons.woff?xegvp7') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: block;\n}\n\n[class^='icon-'],\n[class*=' icon-'] {\n    font-family: 'nut-icons' !important;\n    speak: never;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    font-size: 4em;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-nut-solid-nut-at:before {\n    content: '\\e900';\n}\n.icon-nut-solid-nut-baby:before {\n    content: '\\e901';\n}\n.icon-nut-solid-nut-care:before {\n    content: '\\e902';\n}\n.icon-nut-solid-nut-child:before {\n    content: '\\e903';\n}\n.icon-nut-solid-nut-dislike:before {\n    content: '\\e904';\n}\n.icon-nut-solid-nut-exclamation:before {\n    content: '\\e905';\n}\n.icon-nut-solid-nut-family:before {\n    content: '\\e906';\n}\n.icon-nut-solid-nut-free:before {\n    content: '\\e907';\n}\n.icon-nut-solid-nut-hands:before {\n    content: '\\e908';\n}\n.icon-nut-solid-nut-heart:before {\n    content: '\\e909';\n}\n.icon-nut-solid-nut-instagram:before {\n    content: '\\e90a';\n}\n.icon-nut-solid-nut-like:before {\n    content: '\\e90b';\n}\n.icon-nut-solid-nut-list:before {\n    content: '\\e90c';\n}\n.icon-nut-solid-nut-paid:before {\n    content: '\\e90d';\n}\n.icon-nut-solid-nut-play:before {\n    content: '\\e90e';\n}\n.icon-nut-solid-nut-puzzle:before {\n    content: '\\e90f';\n}\n.icon-nut-solid-nut-tiktok:before {\n    content: '\\e910';\n}\n.icon-nut-solid-nut-toddler:before {\n    content: '\\e911';\n}\n.icon-nut-solid-nut-translate:before {\n    content: '\\e912';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
